'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ContentCardText = require('./ContentCardText');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ContentCardText).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }